import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-layer-popup',
  templateUrl: './layer-popup.component.html',
  styleUrls: ['./layer-popup.component.css']
})
export class LayerPopupComponent implements OnInit {

  @Input() customData: any

  mapData: any = []
  constructor() { }

  ngOnInit(): void {
    console.log(this.customData)
    this.mapData.push(this.customData)
  }


}
